'use strict';

module.exports = function requiredStirng(val) {
  return typeof val === 'string' && val;
};
